import React from 'react';
import useWindowDimensions from '../hooks/useWindowsDimensions';

type ConfirmModalProps = {
  message: string;
  onHardDeleteConfirm: () => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export const HardDeleteConfirmModal: React.FC<ConfirmModalProps> = ({ message, onConfirm, onHardDeleteConfirm, onCancel }) => {
  const { height, width } = useWindowDimensions();

  return (
    <>
      {width && width < 720 ? (
        //  Start - Mobile View
        <div className="modal-overlay fixed inset-0 flex items-center justify-center">
          <div className="modal bg-white rounded-lg shadow-lg p-6 m-4 max-w-sm w-full">
            <p className='text-base font-semibold text-center'>{message}</p>
            <div className='flex justify-center gap-4 mt-6'>
              <button className="bg-red-600 text-white p-4 w-48 h-12" onClick={onHardDeleteConfirm}>Delete Permanently</button>
              <button className='bg-blue-500 text-white py-2 px-6 rounded-md w-32' onClick={onConfirm}>Confirm</button>
              <button className='bg-gray-400 text-white py-2 px-6 rounded-md w-32' onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </div>
        //  End - Mobile View
      ) : width && width >= 720 && width < 1024 ? (
        //  Start - Tablet View
        <div className="modal-overlay fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="modal bg-white rounded-lg shadow-lg p-6 m-4 max-w-md w-full">
            <p className='text-lg font-semibold text-center'>{message}</p>
            <div className='flex justify-center gap-4 mt-6'>
              <button className="bg-red-600 text-white p-4 w-48 h-12" onClick={onHardDeleteConfirm}>Delete Permanently</button>
              <button className='bg-blue-500 text-white py-2 px-6 rounded-md w-36' onClick={onConfirm}>Confirm</button>
              <button className='bg-gray-400 text-white py-2 px-6 rounded-md w-36' onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </div>
        //  End - Tablet View
      ) : (
        //  Start - Web View                  
        <div className="modal-overlay py-4">
          <div className="modal h-48 flex flex-col justify-center items-center">
            <p className='mt-10 font-semibold'>{message}</p>
            <div className='flex flex-row justify-center py-10 gap-4'>
              <button className="bg-red-600 text-white p-4 w-48 h-12" onClick={onHardDeleteConfirm}>Delete Permanently</button>
              <button className='bg-blue-500 text-white p-4 w-40 h-12' onClick={onConfirm}>Confirm</button>
              <button className='bg-gray-400 text-white p-4 w-40 h-12' onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </div>
        //  End - Web View
      )}
    </>
  );
};
